
export class TrainingQuestion {
  id: number;
  order: number;
  text: string;

  public deserialize(input: any, index: number): this {

    this.id = input.id;
    this.order = index + 1;
    this.text = input.question;

    return this;
  }
}
